import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'form-terms',
  templateUrl: './form-terms.component.html',
  styleUrls: ['./form-terms.component.css']
})
export class FormTermsComponent implements OnInit {
  config;
  group: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}
